import React, { useState } from 'react';
import Modal from '../ui/Modal';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import { Grid, Box } from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import EmailIcon from '@mui/icons-material/Email';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function RequestModal(props) {
  const [titlu, setTitlu] = useState('');
  const [mesaj, setMesaj] = useState('');

  return (
    <Modal
      lung
      open={true}
      closed={() => props.updateRequestModal({ active: false })}
    >
      <Grid >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',  width: '65vw', height: '80vh'
          }}
        >
          <Avatar sx={{ m: 1 }}>
            <EmailIcon />
          </Avatar>
          <Typography align='center' component='p' sx={{ mb: 1 }} variant='p'>
            Introdu tematica lucrării de licență și un mesaj pentru profesorul ales.
          </Typography>
          <Alert severity='warning' sx={{ mb: 1, width: '100%', height: '100%' }}>
            <AlertTitle sx={{ fontWeight: 'bold' }}>Titlul de acum NU este cel final</AlertTitle>
            Titlul introdus aici este doar <b>ORIENTATIV</b>. Solicitarea este doar confirmarea unei
            colaborări între tine și profesor. După acceptare, titlul <b>poate fi schimbat</b> împreună
            cu profesorul coordonator, iar titlul <b>final</b> va fi cel trecut în cererea oficială (documentul PDF).
          </Alert>
          <TextField
            margin='normal'
            fullWidth
            id='titltulicenta2'
            placeholder='Titlu orientativ licență'
            onChange={(e) => setTitlu(e.target.value)}
            type='text'
            label='Titlu orientativ licență (nu este cel final)'
            helperText='Poate fi schimbat după acceptarea solicitării.'
            name='Titlul licentei'
            autoComplete='Titlul licentei'
            required
            style={{
              width: '100%',
              resize: 'none',
              fontSize: '1.2em',
            }}
          />
          <TextareaAutosize
            margin='normal'
            required
            aria-label='empty textarea'
            placeholder='Mesaj'
            minRows={10}
            onChange={(e) => setMesaj(e.target.value)}
            style={{
              width: '100%',
              resize: 'none',
              padding: '0.7em',
              fontSize: '1.2em',
              fontFamily: "Arial"
            }}
            maxRows={10}
          />
          <Button
            fullWidth
            variant='contained'
            color='primary'
            sx={{ m: 1 }}
            onClick={() => {
              if(titlu.trim().length > 0 && mesaj.trim().length > 0){
                props.makeRequest(props.modal.professor, titlu, mesaj);
                props.updateRequestModal({ active: false, professor: null });
              } else toast.error('Completează titlul și mesajul!');
            }}
          >
            Solicită
          </Button>
        </Box>
      </Grid>
    </Modal>
  );
}

export default RequestModal;
